export const UPDATE_SUBSCRIBER_QUERY_KEY = ['update', 'subscriber'] as const;

export const COMMUNICATION_MODE_FIELD_NAME = 'communication_mode' as const;
